export type UnsavedChangesReason = "saveFailed" | "fieldsNeedCorrecting";

export class UnsavedChangesError extends Error {
  constructor(
    readonly reason: UnsavedChangesReason = "saveFailed",
    readonly alreadyReported = false,
  ) {
    super("Pending changes could not be saved");
    this.name = "UnsavedChangesError";
  }
}
